<template>
  <div class="social-schedule-calendar">

		<b-modal size="lg" hide-footer id="editSocialModal" title="Edit Social Deliverable" class="modal-edit-social-deliverable" @show="editSocialModalShown" @shown="afterEditSocialModalShown" @hide="editSocialModalHidden" @hidden="removeRoute" no-close-on-backdrop no-close-on-esc>


		<EditSocialModal :allContacts="allContacts" :tabIndex="tabIndex" ref="refEditSocialModal"/>
	</b-modal>

		<div class="deliverable-header">
			<HeaderIcon
				:totalDeliverableCount="this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0"
				:totalOutletCount="this.outletCount ? this.outletCount : 0"
				:myWeek="false"
			/>
		</div>

    <SocialTabs/>

		<div class="calendar-container">
			<div class="calendar" ref="SchedulerComponent"></div>
		</div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { scheduler } from "../../../../lib/dxhtml-scheduler/dhtmlxscheduler.js";
import EditSocialModal from "./EditSocialModal";
import SocialTabs from "../common/SocialTabs";
import HeaderIcon from './HeaderIcon';

export default {
	data() {
		return {
			activeView: '-1',
			showUpdateView: false,
			viewBtnLabel: 'Views',
			currentViewData: {},
			currentFilterData: false,
			showUpdateViewText: false,
			showCreateNewView: false,
			viewId: '',

			viewModalShowCreateView: false,
			viewModalShowUpdateView: false,

			showNewViewTitleArea: false,
			showUpdateViewTitleArea: false,

			showRemoveDeliverableId: null,
			stripRemoveDeliverableId: null,

			undoEnabled: false,
			tabIndex: 2,
		}
	},
	
	created() {
		// this.fetchCalendarDeliverables().then(() => {
		// 	this.mapDeliverableToCalendar();
		// });
		// this.fetchContacts();
		this.fetchDepartments();
		this.fetchActiveDepartments();
		this.fetchProjects();
		this.fetchViews();
		// this.fetchSubjects();
		this.fetchTags();
		this.fetchUsers();
		this.fetchActiveUsers();
		this.fetchGeoData();
		this.fetchAllCustomFields();
	},
	components: {
		EditSocialModal,
		SocialTabs,
		HeaderIcon
	},
	computed: {
		...mapGetters([
			"allContacts",
			"deliverableDetail",
			"deliverableFilter",
			"allCalendarDeliverables",
			"systemSettings",
			'allDeliverablesPaginationData',
			'outletCount',
			'socialMediaFilter',
		]),
		...mapState({
			editDeliverableModal: state => state.deliverables.editDeliverableModal,
			addContactModal: state => state.deliverables.addContactModal,
			editContactModal: state => state.deliverables.editContactModal,
			editSpokespersonModal: state => state.deliverables.editSpokespersonModal,
			editWhoModal: state => state.deliverables.editWhoModal,
			deliverablePublishStatus: state => state.deliverables.deliverablePublishStatus,
		}),
 	},
	methods: {
		...mapActions([
			"fetchDeliverables",
			"createTag",
			"fetchUsers",
			"fetchActiveUsers",
			"fetchContacts",
			"updateFieldValue",
			"fetchDepartments",
			"fetchActiveDepartments",
			"fetchSubjects",
			"fetchTags",
			"fetchGeoData",
			"fetchAllCustomFields",
			"filterDeliverables",
			'fetchViews',
			'fetchProjects',
			'getDeliverableTypes',
			'fetchUserManageProjects',
			"fetchDeliverableCount",
			"fetchCalendarDeliverables",
			"updateCalendarDeliverablePublishDate",
			"undoAction",
			"undoUpdateDeliverablePublishDate",
			"getLangCodeById",
		]),
		...mapMutations([
			"setDataLoading",
			"setSocialMediaFilter",
		]),

		mapDeliverableToCalendar() {
			const { mode } = scheduler.getState();
			const deliverables = this.allCalendarDeliverables.filter(x => x.publish_date);
			const mappedDeliverables = [];
			deliverables.forEach((x) => {
				mappedDeliverables.push({
					id: x.id,
					text: x.title,
					preview: (x.preview) ? _.cloneDeep(x.preview):null,
					manually_updated_at: (x.manually_updated_at) ? x.manually_updated_at:null,
					master_deliverable_id: (x.master_deliverable_id) ? x.master_deliverable_id : null,
					// start_date: this.$moment.utc(x.publish_date).format(),
					// end_date: this.$moment.utc(x.publish_date).format(),
					start_date: x.publish_date,
					end_date: x.publish_date,
					publish_status:JSON.parse(x.publish_status),
					social_series: (x.social_series) ? _.cloneDeep(x.social_series):null,
					social_campaigns: (x.social_campaigns) ? _.cloneDeep(x.social_campaigns):null,
					color: (mode == "day" || mode == "week") ? JSON.parse(x.publish_status).color : undefined,
					textColor: (mode == "day" || mode == "week") ? "white" : JSON.parse(x.publish_status).color,
				});
			});

			scheduler.parse(mappedDeliverables);
		},

		undoClick() {
			if (this.undoEnabled) {

				this.undoUpdateDeliverablePublishDate().then(() => {
					this.undoEnabled = false;
				});
			}
		},
		viewClick() {
			// console.log("viewClick");
		},
		viewEntryClick(e) {
			scheduler.clearAll();

			const target = $(e.currentTarget);
			const statusName = target.attr("status-name");
			const statusObject = this.systemSettings.publish_statuses.find(x => x.name == statusName);

			const socialMediaFilter = this.socialMediaFilter;

			if (statusName == "All Posts") {
				socialMediaFilter.publishStatus = [];
			} else {
				socialMediaFilter.publishStatus = [statusObject];
			}

			this.setSocialMediaFilter(socialMediaFilter);

			// this.setDataLoading(true);
			// this.fetchCalendarDeliverables().then(() => {
			// 	// this.mapDeliverableToCalendar();
			// 	this.setDataLoading(false);
			// });

			const viewLabelText = (this.socialMediaFilter.publishStatus && this.socialMediaFilter.publishStatus.length == 1) ? this.socialMediaFilter.publishStatus[0].name : "Views";
			$(".social-schedule-calendar .view__label").html(viewLabelText);

			this.$root.$emit('calendarSetView');
		},


		editSocialModalShown(){
			document.body.classList.add("social-modal-open");
			// $("#content").scrollTop(this.windowScrollTop);
		},
		afterEditSocialModalShown(){
			document.body.classList.add("social-modal-shown");
			if(this.$router.currentRoute.path.indexOf('social-media/') == -1
			|| this.$router.currentRoute.path.indexOf('social-media-schedule/') == -1
			) {
				history.pushState(
					{},
					null,
					'social-media-schedule/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},


		editSocialModalHidden() {
			document.body.classList.remove("social-modal-open");
			document.body.classList.remove("social-modal-shown");

			if (this.deliverableDetail.is_master) {
				this.setDataLoading(true);
				this.fetchCalendarDeliverables().then(() => {
					// this.mapDeliverableToCalendar();
					this.setDataLoading(false);
				});
			} else {
				this.$store.commit('setCalendarDeliverable', this.deliverableDetail);
			}
		},




		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('social-media/') == -1) {
				history.pushState(
					{},
					null,
					'social-media/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
		removeRoute() {
			if(this.$router.currentRoute.path.indexOf('social-media/') != -1) {
				this.$router.push({name: 'socialMedia'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
				//this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
			}
		},

		showModalFn(deliverableId) {
			// shows edit deliverable modal
			this.$store
				.dispatch("getDeliverableDetail", { deliverableId })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}
					this.$bvModal.show("editSocialModal");
					this.tabIndex = 2;
				});
		},

		changeEventPublishDate(ev) {

			const requestData = {
				id: ev.id,
				value: this.$moment(ev.start_date).toISOString(),
				return: "calendar"
			}

			this.updateCalendarDeliverablePublishDate(requestData).then(() => {
				this.undoEnabled = true;
			});
		},

		onCalendarViewChange(min_date, max_date) {
			document.querySelector(".social-media-view-button").setAttribute("data-toggle", "dropdown");
			$(".social-schedule-calendar .viewmenu-dropdown a.dropdown-item").on("click", (e) => this.viewEntryClick(e));

			const viewLabelText = (this.socialMediaFilter.publishStatus && this.socialMediaFilter.publishStatus.length == 1) ? this.socialMediaFilter.publishStatus[0].name : "Views";
			$(".social-schedule-calendar .view__label").html(viewLabelText);

			const socialMediaFilter = JSON.parse(JSON.stringify(this.socialMediaFilter));
			socialMediaFilter.listByPublishDate = true;
			if (!socialMediaFilter.listDatePublishRange) socialMediaFilter.listDatePublishRange = {};
			socialMediaFilter.listDatePublishRange.startDate = min_date;
			socialMediaFilter.listDatePublishRange.endDate = max_date;

			this.setSocialMediaFilter(socialMediaFilter);

			this.setDataLoading(true);
			this.fetchCalendarDeliverables().then(() => {
				// this.mapDeliverableToCalendar();
				this.setDataLoading(false);
			});

			this.setUndoButtonEnabled();
		},

		setUndoButtonEnabled(v) {
			if (v === undefined) {
				v = this.undoEnabled;
			}

			if (v) {
				$(".social-schedule-calendar .social-media-undo-button").removeClass("disabled");
			} else {
				$(".social-schedule-calendar .social-media-undo-button").addClass("disabled");
			}
		},

		checkIfEventDraggable(id) {
			const targetEvent = this.allCalendarDeliverables.find(x => x.id == id);
			if (!targetEvent) return false;

			const publishStatus = JSON.parse(targetEvent.publish_status);


			// Hardcode
			if (publishStatus.name == 'Posted' || targetEvent.published_at) {
				return false;
			}

			// if (publishStatus.name == 'Posted' || targetEvent.published_at != null) {
			// 	return false;
			// }
			return true;
		},

		checkIfPublishStatusFilterChange(publishStatus) {
			const viewLabelText = (publishStatus && publishStatus.length == 1) ? publishStatus[0].name : "Views";
			$(".social-schedule-calendar .view__label").html(viewLabelText);
		}


	},
	mounted() {
		let that = this;

		let viewDropdownItem = '';
				viewDropdownItem += `<a class="dropdown-item" style="background-color: #2D3135" status-name="All Posts">All Posts</a>`;

		this.systemSettings.publish_statuses.forEach(x => {
			viewDropdownItem += `<a class="dropdown-item" style="background-color: ${x.color}" status-name="${x.name}">${x.name}</a>`;
		});




		scheduler.skin = "material";

		scheduler.config.header = [
			"year",
			"day",
			"week",
			"week_agenda",
			"month",
			"prev",
			"date",
			"next",
			// "today",
			{html:
				`<span class="mr-3 view__label truncate-text">Views</span>
				 <img class="view__icon" src="/images/dropdown-arrow.svg" alt="" />
				<div class="dropdown-menu viewmenu-dropdown">
					<div>
						${viewDropdownItem}
					</div>
				</div>`
				, css: "social-media-view-button"},
			{html:'<span class="mr-3 undo__label truncate-text"><img class="undo-icon" src="/images/undo.svg" alt="" /><span class="undo-text">Undo</span></span>', click:that.undoClick, css: "social-media-undo-button"},
		];
		scheduler.plugins({
			year_view: true
			,week_agenda: true
			,tooltip: true
		});

		scheduler.config.drag_resize = false;
		scheduler.config.dblclick_create = false;
		scheduler.config.server_utc = true;

		scheduler.config.separate_short_events = true;
		// scheduler.config.start_on_monday = false;

		// default is 44px tall
		// scheduler.config.hour_size_px = 44 * 4;
		// scheduler.xy.min_event_height = 40 * 4;

		/*
		scheduler.templates.event_text = function(start,end,event){
				var html = "";
				html += event.text;
				if (typeof event.preview != "undefined") {
					if (typeof event.preview[0].files[0] != "undefined") {
						// html += event.preview[0].files[0];
						let filename = process.env.MIX_API_BASE_URL+"viewFileSocialMediaPost/"+event.preview[0].files[0].social_post_id+"/"+event.preview[0].files[0].id+"/"+	that.$store.getters.authToken;

  						html += '<div class="dhx_event-preview-image" style="background-image:url('+filename+');"></div>';
					}
				}

				html += "";
      	return html;
			};

			scheduler.templates.week_agenda_event_text = function(start,end,event,cellDate,pos){
			    // return scheduler.templates.event_date(start) + " - " + scheduler.templates.event_date(end) + " " + event.text;

  				var html = "";
  				html += scheduler.templates.event_date(start);
  				html += " " + event.text;
  				if (typeof event.preview != "undefined") {
  					console.log(event.preview[0].files[0]);
  					if (typeof event.preview[0].files[0] != "undefined") {
  						// html += event.preview[0].files[0];
  						let filename = process.env.MIX_API_BASE_URL+"viewFileSocialMediaPost/"+event.preview[0].files[0].social_post_id+"/"+event.preview[0].files[0].id+"/"+	that.$store.getters.authToken;

  						html += '<div class="dhx_event-preview-image" style="background-image:url('+filename+');"></div>';
  					}
  				}

  				html += "";
        	return html;
			};
			*/

//			var format = scheduler.date.date_to_str("%Y-%m-%d %H:%i");
			scheduler.templates.tooltip_text = function(start,end,event) {
  				var html = "";

  				html += '<div class="dhx_event-tooltip-wrapper"  style="width:500px;">';

			  	html += '<div class="dhx_event-tooltip-date">'  + scheduler.templates.event_date(start) + '</div>';
			  	html += '<div class="dhx_event-tooltip-title">' + event.text + '</div>';
			  	html += '<div class="dhx_event-tooltip-status" style="background-color:'+event.publish_status.color+'">' + event.publish_status.name + '</div>';
			  	if (event.social_campaigns.length > 0) {
			  		html += '<div class="dhx_event-tooltip-campaign"><span>CAMPAIGN:</span> ' + that.$store.getters.getSocialCampaignNameById(event.social_campaigns) + '</div>';
			  	}
			  	if (event.social_series.length > 0) {
				  	html += '<div class="dhx_event-tooltip-series"><span>SERIES:</span> ' + that.$store.getters.getSocialSeriesNameById(event.social_series) + '</div>';
				  }


  				if (typeof event.preview != "undefined") {
			  						html += '<div class="dhx_event-tooltip-preview-wrapper">';

  						for (var x = 0; x < event.preview.length; x++) {
			  						html += '<div class="dhx_event-tooltip-preview">';
											html += '<div class="dhx_event-tooltip-lang" style="width:250px;">'+that.$store.getters.getLangNameById(event.preview[x].lang_id)+'</div>';


				  					if (typeof event.preview[x].files[0] != "undefined") {
				  						let filename = process.env.MIX_API_BASE_URL+"viewFileSocialMediaPost/"+event.preview[x].files[0].social_post_id+"/"+event.preview[x].files[0].id+"/"+	that.$store.getters.authToken;
											html += '<div class="dhx_event-tooltip-image" style="width:250px;"><img src="'+filename+'"/></div>';
				  					}
				  					if (event.preview[x].caption == null) {
											html += '<div class="dhx_event-tooltip-body" style="width:250px;">No caption</div>';
				  					} else {
											html += '<div class="dhx_event-tooltip-body" style="width:250px;">'+event.preview[x].caption+'</div>';
										}
										html += "</div>";
  						}
										html += "</div>";


  				}
  				html += "</div>";

  				html += "";
        	return html;

			};





		scheduler.init(
			this.$refs.SchedulerComponent,
			new Date(),
			"week"
		);



		// scheduler.getView().event_dy = 44 * 4;

		// scheduler.parse([
		// {
		// 	id: 1,
		// 	start_date: "2020-01-20 6:00",
		// 	end_date: "2020-01-20 6:01",
		// 	text: "Event 1",
        // },
		// {
		// 	id: 2,
		// 	start_date: "2020-01-20 6:00",
		// 	end_date: "2020-01-20 6:01",
		// 	text: "Event 2",
        // },
		// ]);

		scheduler.attachEvent("onViewChange", function (new_mode , new_date){
			const {min_date, max_date} = scheduler.getState();
			that.onCalendarViewChange(min_date, max_date);
		});
		scheduler.attachEvent("onSchedulerResize", function (new_mode , new_date){
			const {min_date, max_date} = scheduler.getState();
			that.onCalendarViewChange(min_date, max_date);
		});

		scheduler.attachEvent("onClick", function (id, e) {
			  var event = scheduler.getEvent(id);
			if (event.master_deliverable_id && event.manually_updated_at == null) {
				that.showModalFn(event.master_deliverable_id);
			} else {
				that.showModalFn(id);
			}
		});


		scheduler.attachEvent("onBeforeEventChanged", function(ev, e, is_new, original){
			// don't let them manually add new entries to the calendar by double-clicking.
			if (is_new) {
					return false;
			}

			that.changeEventPublishDate(ev);
			return true;
		});

		scheduler.attachEvent("onBeforeDrag", function(id) {
			var canDrag = that.checkIfEventDraggable(id);
			return canDrag;
		})

		document.querySelector(".social-media-view-button").setAttribute("data-toggle", "dropdown");

		this.onCalendarViewChange(scheduler.getState().min_date, scheduler.getState().max_date);

		// Click event for view
		$(".social-schedule-calendar .viewmenu-dropdown a.dropdown-item").on("click", (e) => that.viewEntryClick(e));
	},
	watch: {
		allCalendarDeliverables: {
			handler: function () {
				scheduler.clearAll();
				this.mapDeliverableToCalendar();
			},
			deep: true,
		},
		undoEnabled: {
			handler: function (v) {
				this.setUndoButtonEnabled(v);
			}
		},
		socialMediaFilter: {
			handler: function (v) {
				this.checkIfPublishStatusFilterChange(v.publishStatus);
			},
			deep: true
		}
	}
};
</script>